import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { GTR } from 'styles/tokens'

const StyledLink = styled.span`
  cursor: pointer;
`

const ScrollTo = ({ children, scrollId }) => {
  const handleClick = () => {
    // eslint-disable-next-line
    const section = document.querySelector(`[data-scroll-id="${scrollId}"]`)

    if (!section) return false

    const topOfSection = section.offsetTop - parseInt(GTR.XL, 10)
    // eslint-disable-next-line
    window.scrollTo(0, topOfSection)

    return true
  }

  return <StyledLink onClick={handleClick}>{children}</StyledLink>
}

ScrollTo.propTypes = {
  children: PropTypes.node.isRequired,
  scrollId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
}

export default ScrollTo
